const pages = {
  all: '/explore/(.*)?',
  index: '/explore',
  search: '/explore/search',
  deals: '/explore/deals',
  account: '/explore/accounts/:id',
};

export default pages;
